<template>
	<div class="company-location-card">
		<h6>Location Name</h6>
		<span>{{ data.name }}</span>
		<h6>Location Nickname</h6>
		<span>{{ data.nickname }}</span>
		<h6>Parts Location Sourced From *</h6>
		<span>{{ data.source }}</span>
	</div>
</template>

<script>
export default {
	name: 'CompanyLocationCard',
	props: {
		data: {
			type: Object,
			default: () => {}
		}
	}
};
</script>

<style lang="scss" scoped>
.company-name-card {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 12px;

	&__item {
		display: block;
	}

	.section-header {
		display: inline-block;
	}
}
</style>
